/**
 * OC2-3562 — open a URL in View side-by-side with the current page.
 *
 * Mirrors the split-view behaviour in `RichtextLinkWeblinkCommon` and
 * `PrescriptionSection`: when embedded inside a view-side-by-side panel, post
 * the URL to the OPPOSITE panel; otherwise navigate to `/view-side-by-side`
 * with the current page on the left and `rightUrl` on the right.
 */
export interface OpenSideBySideContext {
	isInIframe: boolean
	iframeSide: 'left' | 'right' | null | undefined
}

export const openSideBySideWithUrl = (
	rightUrl: string,
	ctx: OpenSideBySideContext,
): void => {
	if (typeof window === 'undefined') return

	// Inside a view-side-by-side iframe → load the target into the other panel.
	if (ctx.isInIframe) {
		if (ctx.iframeSide) {
			window.parent.postMessage(
				{
					type: `${
						ctx.iframeSide === 'left' ? 'right' : 'left'
					}UrlChange`,
					url: rightUrl,
				},
				'*',
			)
		}
		return
	}

	// Otherwise open side-by-side with the current page on the LEFT and the
	// target on the RIGHT.
	const leftUrl =
		window.location.pathname + window.location.search + window.location.hash
	window.location.href = `/view-side-by-side?l=${encodeURIComponent(
		leftUrl,
	)}&r=${encodeURIComponent(rightUrl)}`
}
